export class VehicleTypeApiModel {
  vehicleTypeId: number;
  name: string;
  isActive: boolean;
  modifyDate: any;
  createDate: any;
}

export class VehicleTypeModel {
  vehicleTypeId: number;
  name: string;
  isActive: boolean;

  static map(vehicleTypeApiModel: VehicleTypeApiModel): VehicleTypeModel {
    let model = new VehicleTypeModel();
    model = { ...model, ...vehicleTypeApiModel };
    return model;
  }
}
